export interface Category {
  slug: string;
  name: string;
  description: string;
  icon: string;
  postCount: number;
}

export const categories: Category[] = [
  {
    slug: 'tech-discussion',
    name: '技术交流',
    description: '分享编程技术、开发经验与行业前沿动态',
    icon: 'ri-code-s-slash-line',
    postCount: 12850,
  },
  {
    slug: 'life-sharing',
    name: '生活分享',
    description: '记录日常生活、美食旅行与美好瞬间',
    icon: 'ri-heart-line',
    postCount: 9632,
  },
  {
    slug: 'investment-finance',
    name: '投资理财',
    description: '探讨股票基金、数字货币与财富管理',
    icon: 'ri-funds-line',
    postCount: 7421,
  },
  {
    slug: 'career-growth',
    name: '职场成长',
    description: '交流职场经验、面试技巧与职业规划',
    icon: 'ri-briefcase-line',
    postCount: 5893,
  },
  {
    slug: 'digital-gadgets',
    name: '数码科技',
    description: '评测数码产品、分享智能设备使用体验',
    icon: 'ri-smartphone-line',
    postCount: 8156,
  },
  {
    slug: 'reading-learning',
    name: '读书学习',
    description: '推荐好书、分享学习心得与知识管理方法',
    icon: 'ri-book-open-line',
    postCount: 4567,
  },
  {
    slug: 'entertainment-leisure',
    name: '娱乐休闲',
    description: '影视推荐、音乐分享与游戏交流',
    icon: 'ri-movie-line',
    postCount: 10982,
  },
  {
    slug: 'health-wellness',
    name: '健康养生',
    description: '交流健康知识、运动健身与养生心得',
    icon: 'ri-mental-health-line',
    postCount: 3245,
  },
];